<div class="content-wrapper table-full-bx">
	<div class="account-settings checkout">
		<div class="row">
			<div class="col-lg-12">
				<div class="ibox ">
					<div class="ibox-body">
						<div class="iboxcontent">
							<h3>Account Settings</h3> </div>
						<!-- Account settings  -->
						<div class="row">
							<div class="col-lg-3 col-sm-12">
								<!-- Tabs nav -->
								<div class="nav nav-pills nav-pills-custom pills-custom">
									<a class="nav-link mb-3 p-3 " href="javascript:void(0);" routerLink="/account-settings/change-password"> <span class=" ">Change password</span> </a>
									<a class="nav-link mb-3 p-3  " href="javascript:void(0);" routerLink="/account-settings/notification" *ngIf="userDatas?.Recruiter?.userType != 'SUB_RECRUITER'"> <span class=" ">Notifications</span> </a>
									<a class="nav-link mb-3 p-3 " href="javascript:void(0);" routerLink="/account-settings/save-card" *ngIf="userDatas?.Recruiter?.userType != 'SUB_RECRUITER'" hidden> <span class=" ">Saved cards</span> </a>
									<a class="nav-link mb-3 p-3  active" href="javascript:void(0);" routerLink="/account-settings/inventory-history"  *ngIf="userDatas?.Recruiter?.userType == 'SUPER_RECRUITER' || (userDatas?.Recruiter?.userType == 'SUB_RECRUITER' && userPermissionData?.viewActivePlans == 1)"> <span class="">Subscriptions</span> </a>
									<a class="nav-link mb-3 p-3 " href="javascript:void(0);" routerLink="/account-settings/billing-address" *ngIf="userDatas?.Recruiter?.userType != 'SUB_RECRUITER'"> <span class=" ">Billing address</span> </a>
									<a class="nav-link mb-3 p-3  " href="javascript:void(0);" routerLink="/account-settings/my-templates" *ngIf="userDatas?.Recruiter?.userType != 'SUB_RECRUITER'"> <span class=" ">My templates</span> </a>
								</div>
							</div>

							<div class="col-lg-8 col-sm-12 tabwidth marginstart">
								<form [formGroup]="form" (ngSubmit)="onOrderSubmit()">
									<section class=" pb-2">
										<div class="container">
											<div class="topHeader mb-2">
												<a href="javascript:void(0)" (click)="goToBack(prodId)" class="bkbtn"><img src="../../../../assets/images/arrow_back.svg" class="ht" /> Back</a>
											</div>
											<div class="personal-info">
												<div class="row">
													<div class="col-lg-6 col-md-6 col-sm-12 paymentinfo">
														<h6>Shopping cart</h6>
														<div class="basic">
															<h6>{{allData?.planName}} <span class="price">${{allData?.planAmount}}</span></h6>
															<p>{{allData?.numberOfJob}} Job posting for {{allData?.validity + " Months"}}</p>
														</div>
							
														<p class="para7">Subtotal <span>${{allData?.planAmount}}</span></p>
														<p class="para7">Taxes<span>{{taxAmount || "0"}}</span></p>
														<p class="para7 green-text" *ngIf="discountPercentage">Discount ({{discountPercentage + "%"}}) <span>  $ {{ allData?.planAmount -(allData?.planAmount - (allData?.planAmount * discountPercentage)/100)}}</span></p>
							
														<p  class="para7"  *ngIf="allData?.planType == 0"  hidden>
															<span><img src="../../../../assets/images/information.svg" >Allow recurring payments</span>
															<label class="switch on-off">
															  <input type="checkbox" [checked]="userDatas?.Recruiter?.subscribePayment==1"  *ngIf="userDatas?.Recruiter?.subscribePayment==1" disabled>
															  <span class="slider round" (click)="recurringPaymentOn(userDatas?.Recruiter?.subscribePayment)"></span>
															</label> 
														</p>
																				
														<form [formGroup]="promoCode">
															<div class="form-group">
																<label> Promo code</label>
																<input type="text" class="form-control"  placeholder="XYZ31For" formControlName="promoCode" maxlength="8">
																<div class="text-danger" *ngIf="promoCode.controls['promoCode'].hasError('required') && showPromoCodeError">
																	*Please enter promo code.
																</div> 
																<div class="choose" *ngIf="!havePromo">
																	<input type="submit" class="planbtn" value="Apply" [disabled]="!(promoCode.valid)" (click)="applyPromo()">
																</div>
																<div class="choose" *ngIf="havePromo">
																	<input type="submit" class="planbtn" value="Cancel" (click)="removePromo()">
																</div>
															</div>
														</form>
														<div class="totat ">
															<div class="massage-sect">
																<p class="para7">Total 	<strong>$ {{finalAmount || "0"}} </strong></p>
															
																<!-- <p class="money">$ {{discountPercentage == null ? allData?.planAmount : allData?.planAmount - ((allData?.planAmount * discountPercentage)/100)}}</p> -->
															</div>
														</div>
													</div>
													<div class="col-md-6 col-sm-12 col-lg-6 paymentinfo">
														<h6>Payment Information</h6>
														<div class="flexbox" hidden>
															<a data-toggle="modal" data-target="#newCard1" data-dismiss="modal" class="remove" (click)="openModal(addMore)">Add New Card</a>
														</div>
															<!-- <div class="text-danger" *ngIf="form.value.cardId == null || form.value.cardId == '' && showErrorCard">
																*Please add the card.
															</div> -->
														<div *ngIf="allCardData.length > 0" hidden>
															<div *ngFor="let crd of allCardData; let i=index;" hidden> 
																<div>
																	<div class="form-group">
																		<label>Credit card number</label>
																		<input type="text" class="form-control"  placeholder=" XXXX XXXX XXXX 47790 " value=" XXXX XXXX XXXX {{crd?.last4}}" readonly>
																	</div>  
																	<div class=" d-flex justify-content-between">
																		<div class="form-group">
																			<label>Exp date</label>
																			<input type="input" class="form-control"   value="{{crd?.expMonth}} / {{crd?.expYear.slice(-2)}}" readonly>
																		</div>
																		<div class="form-group">
																			<label>CVV number</label>
																			<input type="input" class="form-control" value="***" readonly>
																		</div>
																	</div> 
																		<div class="form-group">
																		<label>Name on the card</label>
																		<input type="text" class="form-control" value="{{crd?.cardHolderName}}" readonly>
																	</div>  
																	
																	<!-- <div class="form-group" *ngIf="allCardData?.isPrimary == 0">
																		<a  class="remove" (click)="deleteCard(allCardData?.id)">Delete Card</a>
																	</div> -->
																</div>
															</div>
															<ul class="userInfolist cardList">
																<li *ngFor="let crd of allCardData; let i=index;">
																	<div class="radioWrap"  (click)="setcard(crd)">
																		<input type="radio" 
																		[checked]="crd?.isPrimary == 1" (change)="crd.isPrimary==1" readonly /> 
																		<label for="jobs1">**** **** **** {{crd?.last4}}</label>
																	</div> 
																</li> 
																	
															</ul>
															<small class="infomation">Note:The selected card will automatically set as default card</small>
														</div> 
														<div class="flexbox">
															<div class="iboxcontent">
																<h6>Billing address</h6>
															</div>
															<div class="col-list-right">
																	<a class="remove" href="javascript:void(0)" routerLink="/account-settings/billing-address">Edit Address</a>
															</div>
													</div>
														<div class="d-flex justify-content-between">
															<div class="form-group">
																<label>Full Name <span class="orange">*</span></label>
																<input type="input" class="form-control"  placeholder="Enter" formControlName="firstName" minLength="3" maxlength="30" readonly/>
																<div class="text-danger" *ngIf="form.controls['firstName'].hasError('required') && showError">
																	*Please enter first name.
																</div> 
																<div class="text-danger" *ngIf="form.controls['firstName'].hasError('minlength') && showError">
																	*Minimum length of 3 characters.
																</div> 
															</div>
							
															<div class="form-group">
																<label>Last Name <span class="orange">*</span></label>
																<input type="input" class="form-control" placeholder="Enter" formControlName="lastName" minLength="3" maxlength="30" readonly/>
																<div class="text-danger" *ngIf="form.controls['lastName'].hasError('required') && showError">
																	*Please enter Last name.
																</div>  
																<div class="text-danger" *ngIf="form.controls['lastName'].hasError('minlength') && showError">
																	*Minimum length of 3 characters.
																</div>        
															</div>
														</div>
														<div class="form-group">
															<label>Phone number <span class="orange">*</span></label>
															<div class="countryCode">
															  <span><input type="text" class="form-control" formControlName="countryCode" readonly placeholder="(+1)"/></span>
															  <input type="text" class="form-control" placeholder="Enter " formControlName="phoneNumber" appPhoneMask id="phone-number" (keypress)="preventNumbers($event)"  maxlength="10" readonly>
															</div>
															<div class="text-danger" *ngIf="form.controls['phoneNumber'].hasError('required') && showError">
																*Please enter phone number.
															</div>
														</div>
														<div class="form-group">
															<label>Company name <span class="orange">*</span></label>
															<input type="text" class="form-control"  placeholder="Enter" formControlName="companyName" maxlength="30" readonly/>
															<div class="text-danger" *ngIf="form.controls['companyName'].hasError('required') && showError">
																*Please enter company name.
															</div>   
															<div class="text-danger" *ngIf="form.controls['companyName'].hasError('minlength') && showError">
																*Minimum length of 3 characters.
															</div> 
														</div>
														<div class="form-group">
															<label>Address <span class="orange">*</span></label>
															<textarea type="text" class="form-control"  placeholder=" Cr 92 No. 34E-112, Medellín" formControlName="address" readonly></textarea>
															<div class="text-danger" *ngIf="form.controls['address'].hasError('required') && showError">
																*Please enter address.
															</div>
														</div>
														<div class="form-group">
															<label>State <span class="orange">*</span></label>
															<input type="input" class="form-control"  placeholder="Enter" formControlName="state" readonly/>
															<select class="form-control" formControlName="state" hidden>
															  	<option selected="selected" disabled  hidden> Please select</option>
															  	<option *ngFor="let states of allStates;let i=index;" [value]="states.name"> {{states.name}}</option>
															</select> 
															<div class="text-danger" *ngIf="form.controls['state'].hasError('required') && showError">
																  *Please enter state.
															</div>
														</div>
														<div class="d-flex justify-content-between">
															<div class="form-group">
																<label>City <span class="orange">*</span></label>
																<input type="text" class="form-control" placeholder="Enter " formControlName="city" readonly>
																<div class="text-danger" *ngIf="form.controls['city'].hasError('required') && showError">
																	*Please enter city.
																</div>
															</div>
							
															<div class="form-group">
																<label>Zip Code</label>
																<input type="input" class="form-control" placeholder="Enter" formControlName="zipCode" (keypress)="preventNumbers($event)" maxlength="6" readonly>
																<div class="text-danger" *ngIf="form.controls['zipCode'].hasError('required') && showError">
																	*Please enter zip code.
																</div>       
															</div>
														</div>
														<div class="form-group">
															<label> Country <span class="orange">*</span></label>
															<input type="input" class="form-control"  placeholder="Enter" formControlName="countryName" readonly/>
															<select class="form-control" formControlName="countryName" hidden>
															  	<option disabled selected> Please select</option>
															  	<option value="USA"> USA</option>
															</select>
															<div class="text-danger" *ngIf="form.controls['countryName'].hasError('required') && showError">
																*Please enter country.
															</div>
														</div>
													</div>
												</div>
											</div>
										</div>
									</section>
	
									<footer class="footer-subscription">
										<div class="row">
											<div class="col-md-6" style="opacity: 0;">
												<div class="icon"><img src="../../../../assets/images/cart.svg" class="wt"></div>
												<div class="massage-sect">
													<p> Total </p>
													<h6>$ {{finalAmount || "0"}} </h6>
													<!-- <p class="money">$ {{discountPercentage == null ? allData?.planAmount : allData?.planAmount - ((allData?.planAmount * discountPercentage)/100)}}</p> -->
												</div>
											</div>
											<div class="col-md-6 text-right">
												<input type="submit" class="commonBtn2 continuebtn" value="Complete Order"/>
												<!-- <a href="javascript:void(0);" class="commonBtn2 continuebtn"> Complete order </a> -->
											</div>
										</div>
									</footer>
								</form>
							</div>
							
						</div>
						<!-- End -->
					</div>
				</div>
			</div>
		</div>
	</div>
</div>

<!--Add new card  -->
<ng-template #addMore>
	<div class="modal-body">
		<div class="tab-content">
			<h6 class="pageTitle">Add New Card</h6>
			<form [formGroup]="cardform" (ngSubmit)="createToken()">
				<p class="total" hidden>Total Amount after including Tax:
					<input type="text" formControlName="amount" readonly> </p>
				<div class="form-group">
					<label for="">Name on the card</label>
					<input type="" class="form-control" placeholder="Albert stonis" formControlName="name" maxlength="30">
					<div class="text-danger" *ngIf="cardform.controls['name'].hasError('required') && showErrorCard"> *Please enter name. </div>
				</div>
				<div class="form-group">
					<label for="">Card number</label>
					<input type="" class="form-control" placeholder="2245 5937 2421 7541" formControlName="CardNumber" maxlength="19" (keyup)="keyUPvalue1($event)">
					<div class="text-danger" *ngIf="cardform.controls['CardNumber'].hasError('required') && showErrorCard"> *Please enter Card Number. </div>
					<div class="text-danger" *ngIf="cardform.controls['CardNumber'].hasError('minlength') && showErrorCard"> *Minimum length of 16 characters. </div>
					<div class="text-danger" *ngIf="!cardform.controls['CardNumber'].hasError('required') && !cardform.controls['CardNumber'].hasError('minlength') && cardform.controls['CardNumber'].hasError('whitespace') && showErrorCard"> *Please enter a valid value. </div>
				</div>
				<div class="row">
					<div class="col-md-6">
						<div class="form-group datepicker">
							<label for="">Expiry Date</label>
							<input type="" class="form-control" type="tel" maxlength="5" class="form-control" placeholder="MM / YY" maxlength="5" (keyup)="keyUPvalue($event)" formControlName="CardExpired" autocomplete="off">
							<div class="text-danger" *ngIf="cardform.controls['CardExpired'].hasError('required') && showErrorCard"> *Please select Card Exp. </div>
							<div class="text-danger" *ngIf="cardform.controls['CardExpired'].hasError('minlength') && showErrorCard"> *Minimum length of 4 characters. </div>
						</div>
					</div>
					<div class="col-md-6">
						<div class="form-group">
							<label for="">CVV</label>
							<input type="password" class="form-control" placeholder="123" formControlName="CardCCV" maxlength="4" autocomplete="off">
							<div class="text-danger" *ngIf="cardform.controls['CardCCV'].hasError('required') && showErrorCard"> *Please enter CVV Number. </div>
							<div class="text-danger" *ngIf="cardform.controls['CardCCV'].hasError('minlength') && showErrorCard"> *Minimum length of 3 characters. </div>
							<div class="text-danger" *ngIf="!cardform.controls['CardCCV'].hasError('required') && !cardform.controls['CardCCV'].hasError('minlength') && 
                  				cardform.controls['CardCCV'].hasError('whitespace') && showErrorCard"> *Please enter a valid value. </div>
						</div>
					</div>
				</div>
				<div class="custom-control custom-checkbox" hidden>
					<input type="checkbox" class="custom-control-input" id="customCheck" formControlName="isSaved" [checked]="cardform.value.isSaved ==1" (change)="cardform.value.isSaved ==1">
					<label class="custom-control-label" for="customCheck"> Save card for future </label>
				</div> 
				<div class="form-group">
					<input type="submit" class="commonBtn width50" value="Save Card"> </div>
			</form>
		</div>
	</div>
</ng-template>

<!-- Delete card  -->
<ng-template #delete>
	<div class="modal-body text-center">
		<div class="tab-content text-center">
			<h6 class="pageTitle">Are you sure you want to <br> Delete The Card</h6>
			<p>You can't undo this action</p>
			<div class="form-group  mt-4">
				<ul class="list text-center"> <a class="addMoreBtn greyBtn" (click)="closeModal()">Cancel</a> <a class="orangeBtn">Remove</a> </ul>
			</div>
		</div>
	</div>
</ng-template>

<ng-template *ngIf="showThankyou">
	<div class="modal-body">
		<figure> <img src="../../../../assets/images/tick_icon.gif" alt="git icon" /> </figure>
		<p class="ft-wt">Thankyou!</p>
		<p>Your payment is successful</p>
	</div>
</ng-template>

<div class="modal fade " *ngIf="showThankyou" [ngClass]="showThankyou ? 'open' : ''">
	<div class="modal-dialog modal-dialog-centered modal-sm ">
		<div class="modal-content thankyou">
			<div class="modal-body">
				<figure> <img src="../../../../assets/images/tick_icon.gif" alt="git icon" /> </figure>
				<p class="ft-wt">Thankyou!</p>
				<p>Your payment is successful</p>
			</div>
		</div>
	</div>
</div>

<!-- stripe for subscription-->
<div class="modal-dialog showSubscribeFrom" [ngClass]="showSubscribeFrom ? 'open' : ''">
		<div class="modal-content ">
			<div class="modal-body">
				<form id="payment-form"> 
					<div id="payment-element">
						<!-- Elements will create form elements here -->
					</div>
					<button id="submit" (click)="onStripeConfirmation()" class="planbtn fill">Subscribe</button>
					<div id="error-message">
						<!-- Display error message to your customers here -->
					</div>
				</form>
			</div>
	</div>
</div>
<!-- stripe for inventory-->
<!-- <div class="modal-dialog showInventoryFrom" [ngClass]="showInventoryFrom ? 'open' : ''">
		<div class="modal-content ">
			<div class="modal-body">
				<form id="payment-form"> 
					<div id="payment-element">
					</div>
					<button id="submit" (click)="onStripeInventroyConfirmation()" class="planbtn fill">Submit</button>
					<div id="error-message">
					</div>
				</form>
			</div>
	</div>
</div> --> 